import React from 'react';

import {
  NewAutomationExperience,
  NewAutomationGifts,
  NewAutomationRules,
  NewAutomationReviewAndActivePage,
  AutomationOrderConfirmed,
  NewAutomationRecipients
} from '@hero/pages';

import { paths } from '../paths';

const newAutomationRoutes = [
  {
    path: paths.NEW_AUTOMATION_GIFTS,
    middlewares: [{ key: 'page-status', provider: 'ValidationErrorsProvider' }],
    element: <NewAutomationGifts />,
    state: {
      pageKey: 'NewAutomation',
      metadata: {
        title: 'Pick your gifts'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.NEW_AUTOMATION_RULES,
    middlewares: [{ key: 'page-status', provider: 'ValidationErrorsProvider' }],
    element: <NewAutomationRules />,
    state: {
      pageKey: 'NewAutomation',
      metadata: {
        title: 'Select rule'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.NEW_AUTOMATION_RECIPIENTS,
    middlewares: [{ key: 'page-status', provider: 'ValidationErrorsProvider' }],
    element: <NewAutomationRecipients />,
    state: {
      pageKey: 'NewAutomation',
      metadata: {
        title: 'Add your recipients'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.NEW_AUTOMATION_EXPERIENCE,
    middlewares: [{ key: 'page-status', provider: 'ValidationErrorsProvider' }],
    element: <NewAutomationExperience />,
    state: {
      pageKey: 'NewAutomation',
      metadata: {
        title: 'New automation experience'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.NEW_AUTOMATION_REVIEW_ACTIVE(),
    middlewares: [{ key: 'page-status', provider: 'ValidationErrorsProvider' }],
    element: <NewAutomationReviewAndActivePage />,
    state: {
      pageKey: 'NewAutomation',
      metadata: {
        title: 'Review & Active'
      },
      shoppingCart: {
        enabled: false
      }
    }
  },
  {
    path: paths.NEW_AUTOMATION_ORDER_CONFIRMED(),
    element: <AutomationOrderConfirmed />,
    state: {
      pageKey: 'NewAutomation',
      metadata: {
        title: 'Order Confirmed'
      },
      shoppingCart: {
        enabled: false
      }
    }
  }
];

export { newAutomationRoutes };
